import GetStartedButton from './GetStartedButton';

export default GetStartedButton;
